<img adEl src="/assets/apex-logo.svg" alt="Apex" class="apex-logo-mark" />
